import { useEffect, useState } from "react";

const londonNow = () => {
  const p = new Date().toLocaleString("en-GB", { timeZone: "Europe/London", weekday: "short", hour: "2-digit", hour12: false });
  const [day, hour] = p.split(" ");
  return { day, hour: Number(hour) };
};
const isOpen = ({ day, hour }) => !["Sat", "Sun"].includes(day) && hour >= 7 && hour < 18;

export const OpenBadge = ({ className = "" }) => {
  const [now, setNow] = useState(londonNow());
  useEffect(() => {
    const t = setInterval(() => setNow(londonNow()), 60000);
    return () => clearInterval(t);
  }, []);
  const open = isOpen(now);
  return (
    <span
      data-testid="open-status-badge"
      className={`inline-flex items-center gap-2 border border-white/10 bg-white/[0.03] px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] ${className}`}
    >
      <span className={`h-2 w-2 rounded-full ${open ? "bg-emerald-500 pulse-dot" : "bg-slate-500"}`} />
      {open ? "Bench open" : "Closed"} · Mon–Fri 7am–6pm
    </span>
  );
};
